import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PolicyActionsFailure, PolicyActionsRequest, PolicyActionsSuccess } from './actions';
import { Action as PremiumAction } from '@models/swagger';

export const featureKey = 'actions';

export interface State {
  data: PremiumAction[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PolicyActionsFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(PolicyActionsRequest, state => ({ ...state, error: null, loading: true })),
    on(PolicyActionsSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
